import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import { connect } from 'react-redux';
import { CaptchaProvider } from "../../../../entities/captcha/model";
import { addMessage as _addMessage, setIsNoNAuthCaptchaStage as _setIsNoNAuthCaptchaStage, updateMessage as _updateMessage } from "../../../../entities/message/model";
import { selectChatCofig } from "../../../../entities/settings/model";
import { selectReconnectCount } from "../../../../entities/socket/model";
var CaptchaServiceRender = function CaptchaServiceRender(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CaptchaProvider, props, children);
};
var mapStateToProps = function mapStateToProps(store) {
  return {
    reconnectCount: selectReconnectCount(store),
    config: selectChatCofig(store)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    addMessage: function addMessage(message) {
      return dispatch(_addMessage(message));
    },
    updateMessage: function updateMessage(message) {
      return dispatch(_updateMessage(message));
    },
    setIsNoNAuthCaptchaStage: function setIsNoNAuthCaptchaStage(flag) {
      return dispatch(_setIsNoNAuthCaptchaStage(flag));
    }
  };
};
export var CaptchaService = connect(mapStateToProps, mapDispatchToProps)(CaptchaServiceRender);